<div class="wow fadeIn"
     data-wow-duration="500ms">

   <div class="homeBannerMain">
      <ngx-slick-carousel class="carousel"
                          #slickModal="slick-carousel"
                          [config]="slideConfig">

         <!-- <div ngxSlickItem class="homeBanner to-win">
            <div class="bannerTitle">
               <div class="mainText sapientsansblack wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  A MISSION <br> TO <span class="highlightWord">WIN</span>
               </div>
               <div class="sapientsansmedium subText wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="300ms">Group ONE Holdings
               </div>
               <a routerLink="/capitals/media"
                  class="banner-link margin-t-10 sapientsansmedium wow fadeInUp"
                  data-wow-duration="500ms" data-wow-delay="500ms">See Our Businesses</a>
            </div>
         </div>
         <div ngxSlickItem class="homeBanner incedo-banner">
            <div class="bannerTitle">
               <div class="mainText sapientsansblack wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  A MISSION <br>TO TRANSFORM
               </div>
               <div class="sapientsansmedium subText wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="300ms">Incedo
               </div>
               <a routerLink="/capitals/platform-services"
                  class="banner-link margin-t-10 sapientsansmedium wow fadeInUp"
                  data-wow-duration="500ms" data-wow-delay="500ms">See Our Businesses</a>
            </div>
         </div>
         <div ngxSlickItem class="homeBanner re-define">
            <div class="bannerTitle">
               <div class="mainText sapientsansblack">
                  A mission <br> to <span class="highlightWord">RE-DEFINE</span>
               </div>
               <div class="sapientsansmedium subText">Deserve</div>
               <a routerLink="/capitals/fintech"
                  class="banner-link margin-t-10 sapientsansmedium">See Our Businesses</a>
            </div>
         </div>
         <div ngxSlickItem class="homeBanner to-give">
            <div class="bannerTitle">
               <div class="mainText sapientsansblack">
                  A mission <br> to <span class="highlightWord">GIVE</span>
               </div>
               <div class="sapientsansmedium subText">Parivaar</div>
               <a routerLink="/philanthropy"
                  class="banner-link margin-t-10 sapientsansmedium">See Our Philanthropy</a>
            </div>
         </div> -->
         <div ngxSlickItem class="homeBanner mission-holdings largeTitle">
            <div class="bannerTitle">
               <div class="mainText sapientsansblack margin-b-30">
                  <div class="">MISSION HOLDINGS</div>
               </div>
               <div class="subText sapientsansmedium font-28 line-35">
                  <p>
                     Mission Holdings is the strategic investment <br> vehicle for billionaire entrepreneur and investor
                     <span class="name">Saurabh Mittal</span>
                  </p>
                  <p>
                     Strategic long-term partner helping our Entrepreneurs build industry leading global-scale
                     businesses.
                  </p>
               </div>

               <a routerLink="/about-mission" class="btn round-corner font-15 text-normal width-150 proximaNovaSb wow fadeInUp"
                  data-wow-duration="500ms" data-wow-delay="100ms">Learn more</a>
            </div>
         </div>
      </ngx-slick-carousel>
   </div>


   <!-- <div class="sliderSec scrollblock parallaxBlock">
      <ul class="homeSlider" id="homeSlider">
         <li class="slide slide1">
            <div class="sliderContent contentBox text-align-center">
               <div class="font-20 text-align-center margin-b-30 wow fadeInUp"
                    data-wow-duration="500ms">ABOUT MISSION
               </div>
               <div class="sapientsansmedium margin-b-30 font-26 subHeading wow fadeInUp line-35"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  Mission Holdings is the strategic investment <br> vehicle for billionaire entrepreneur and investor
                  <span class="name">Saurabh Mittal</span>
               </div>
               <a routerLink="/about-mission"
                  class="btn round-corner font-15 text-normal width-150 proximaNovaSb wow fadeInUp"
                  data-wow-duration="500ms" data-wow-delay="100ms">Learn more</a>
            </div>
         </li>
      </ul>
   </div> -->

   <!-- <div class="press-section pageSection">
      <div class="contentBox font-20">
         <div class="font-20 press-title text-align-center margin-b-30 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">PRESS
         </div>
         <ul class="col-3 press-content margin-b-50">
            <li>
               <div class="press-icon height-30 margin-b-30">
                  <img src="assets/images/The_Indian_Express.png" alt="">
               </div>
               <div class="margin-b-15 font-14 sapientsansmedium light-color">05 Apr 2022</div>
               <div class="margin-b-30 sapientsansmedium wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <a href="https://indianexpress.com/article/cities/delhi/iit-delhi-gets-indoor-sports-complex-spread-over-2000-square-meters-7849071/"
                     target="_blank" class="highlight-color">
                     IIT-Delhi gets indoor sports complex spread over 2,000 square meters
                  </a>
               </div>
               <div class="line-25  wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="200ms">
                  The complex has four badminton courts, two squash courts, two table tennis halls, an open-air theatre,
                  office space, a conference room and a terrace garden.
               </div>
            </li>
            <li>
               <div class="press-icon height-50 margin-b-30">
                  <img src="assets/images/prn_cision_logo.png" alt="">
               </div>
               <div class="margin-b-15 font-14 sapientsansmedium light-color">22 Dec 2021</div>
               <div class="margin-b-30 sapientsansmedium wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <a href="https://www.prnewswire.com/news-releases/group-one-closes-us150-million-equity-financing-round-led-by-guggenheim-investments-and-qatar-investment-authority-301450223.html"
                     target="_blank" class="highlight-color">
                     Group ONE Closes US$150 Million Equity Financing Round Led by Guggenheim Investments and Qatar
                     Investment Authority
                  </a>
               </div>
               <div class="line-25  wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="200ms">
                  Group ONE Holdings ("ONE" or the "Company"), Asia's largest global sports media platform and parent
                  company of ONE Championship and ONE Esports
               </div>
            </li>
            <li>
               <div class="press-icon height-80 margin-b-30">
                  <img src="assets/images/iitd.png" alt="">
               </div>
               <div class="margin-b-15 font-14 sapientsansmedium light-color">6 Aug 2021</div>
               <div class="margin-b-30 sapientsansmedium wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <a href="https://home.iitd.ac.in/show.php?id=36&in_sections=Press"
                     target="_blank" class="highlight-color">
                     IIT Delhi Establishes Chairs to Support Research in Microelectronics & VLSI Design and Geotechnical
                     & Geo-Environmental Engineering
                  </a>
               </div>
               <div class="line-25  wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="200ms">
                  IIT Delhi alumnus Mr Saurabh Mittal (B. Tech. in Electrical Engineering, 1995 Batch) has endowed two
                  Chairs in honour of Prof G.S. Visweswaran and Prof Manoj Datta at IIT Delhi.
               </div>
            </li>
         </ul>

         <div class="text-align-center wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="100ms">
            <a routerLink="/news"
               class="btn round-corner width-150 proximaNovaSb font-15 text-normal">See more</a>
         </div>
      </div>
   </div> -->


</div>
